import { SAVE_USER } from "../constants/actionTypes";

export const setUser = (id, data) => ({
  type: SAVE_USER,
  id,
  data
});
